import Toast from "../../components/Toast";
import Layout from "../../components/Layout";
import styles from "./Projects.module.css"
import projectsData from '../../data/projects.json';
import ProjectCommitStatus from '../../components/ProjectCommitStatus/ProjectCommitStatus';

export default function Projects() {

    const petProjects = projectsData.projects || [];

    return (
        <Layout>
            <div className={styles.mainContainer}>
                <div className={styles.title}>Проекты</div>
                <div className={styles.description}>Коллекция проектов для практики и портфолио</div>
            </div>
            <div className={styles.petProjectsContainer}>
                {/* Проверка на наличие проектов */}
                {petProjects && petProjects.length > 0 ? (
                    <div className={styles.projectsGrid}>
                        {petProjects.map((project) => (
                            <div key={project.id} className={styles.projectCard}>
                                {/* Бейдж статуса в правом верхнем углу */}
                                <div className={`${styles.projectStatus}`}>
                                    <ProjectCommitStatus
                                        status={project.status}
                                        statusType={project.statusType}
                                        githubOwner={project.githubOwner}
                                        repoName={project.repoName}
                                        className={styles.projectStatus}
                                    />
                                </div>

                                <h3 className={styles.projectName}>{project.name}</h3>

                                <div className={styles.techStack}>
                                    {project.tech.map((technology, index) => (
                                        <span key={index} className={styles.techTag}>
                                {technology}
                            </span>
                                    ))}
                                </div>

                                <p className={styles.projectDescription}>
                                    {project.description}
                                </p>

                                <div className={styles.projectLinks}>
                                    {project.links.map((link, index) => (
                                        <a
                                            key={index}
                                            href={link.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`${styles.projectLink} ${styles[link.type]}`}
                                        >
                                            <div className={`${styles.socialItemImg} ${styles.githubIcon}`}/>
                                            <span>{link.label}</span>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.emptyState}>
                        <div className={styles.emptyIcon}>📂</div>
                        <h4 className={styles.emptyTitle}>Проекты пока отсутствуют</h4>
                        <p className={styles.emptyText}>
                            Сейчас активно работаю над новыми идеями и проектами<br/>
                        </p>
                    </div>
                )}
            </div>
            <Toast/>
        </Layout>
    );
}
